export default __webpack_public_path__ + "static/media/cc-license-box.9a024bef.png";